import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../api';

function WebEmbed({ refreshKey, panelId }) {
  const [url, setUrl] = useState('');
  const [savedUrl, setSavedUrl] = useState('');
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);

  const loadConfig = useCallback(async function () {
    try {
      const res = await apiFetch(`/api/settings/web-embed/${encodeURIComponent(panelId || 'web-embed')}`);
      if (res.ok) {
        const data = await res.json();
        if (data.url) {
          setSavedUrl(data.url);
          setUrl(data.url);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [panelId]);

  useEffect(() => {
    loadConfig();
  }, [refreshKey, panelId, loadConfig]);

  async function saveUrl(e) {
    e.preventDefault();
    const trimmed = url.trim();
    try {
      await apiFetch(`/api/settings/web-embed/${encodeURIComponent(panelId || 'web-embed')}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url: trimmed }),
      });
      setSavedUrl(trimmed);
      setEditing(false);
    } catch (err) {
      console.error(err);
    }
  }

  if (loading) {
    return (
      <section className="card">
        <h2>Web Embed</h2>
        <p className="loading">Loading...</p>
      </section>
    );
  }

  if (!savedUrl || editing) {
    return (
      <section className="card web-embed-section">
        <h2>Web Embed</h2>
        <form onSubmit={saveUrl} className="web-embed-form">
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com"
            className="web-embed-input"
            autoFocus
          />
          <div className="web-embed-form-actions">
            <button type="submit" className="manage-btn" disabled={!url.trim()}>
              Save
            </button>
            {savedUrl && (
              <button
                type="button"
                className="receipt-action-btn ignore-btn"
                onClick={() => { setUrl(savedUrl); setEditing(false); }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </section>
    );
  }

  return (
    <section className="card web-embed-section web-embed-active">
      <div className="web-embed-header">
        <h2>Web Embed</h2>
        <button
          className="receipt-action-btn view-btn"
          onClick={() => setEditing(true)}
        >
          Configure
        </button>
      </div>
      <iframe
        src={savedUrl}
        title="Web Embed"
        className="web-embed-iframe"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </section>
  );
}

export default WebEmbed;
